import { BookedGuestSurveyDisplayStatus, ReservationType } from "@/lib/gql/__generated__/graphql";

import { convertRequiredPrepMillisecondIntoRequiredPrepMillisecondBeforeDateAndHour } from "@/components/features/_shared/validation-schema/converter";

import type { AccommodationHotelPolicyFormModel } from "../type";

type Props = {
	queryData: AccommodationHotelPolicyFormModel["QueryData"];
};

export const DEFAULT_ACCOMMODATION_HOTEL_POLICY_INPUT_MODEL = ({ queryData: _queryData }: Props) => {
	const requiredPrepMillisecond = 0;
	const { requiredPrepMillisecondBeforeDate, requiredPrepMillisecondBeforeHour } =
		convertRequiredPrepMillisecondIntoRequiredPrepMillisecondBeforeDateAndHour(requiredPrepMillisecond);

	const inputModel: AccommodationHotelPolicyFormModel["InputModel"] = {
		amenities: [],
		calcAdultPriceAsTotalNum: false,
		cancelPolicy: [],
		checkInEnd: "",
		checkInStart: "",
		checkOut: "",
		facilities: [],
		hotelInfo: [],
		id: "",
		kidsCosleepingPolicy: undefined,
		kidsPolicy: [],
		additionalFees: [],

		baseReservationType: ReservationType.Normal,
		defaultInitPeopleNum: 1,
		defaultPlanID: null,
		hideMailMagazineQuestion: false,
		isLocalPaymentAvailable: false,
		isShowRoomPriceInCalender: true,
		isShowPlanIncludedPrice: false,
		isShowBestRateNotice: false,
		isShowCheckInOutTime: true,
		bookedGuestSurveyDisplayStatus: BookedGuestSurveyDisplayStatus.Unset,
		isCalendarStartFromAvailableMonth: false,

		localPaymentCancelFeeTransferInfo: undefined,

		localPaymentCancelFeeTransferLimitDays: {
			limitDays: 7,
		},

		questions: [] satisfies AccommodationHotelPolicyFormModel["InputModel"]["questions"],

		requiredPlanSelectForReservation:
			false satisfies AccommodationHotelPolicyFormModel["InputModel"]["requiredPlanSelectForReservation"],

		requiredPrepMillisecond: 0,
		requiredPrepMillisecondBeforeDate,
		requiredPrepMillisecondBeforeHour,
	} satisfies AccommodationHotelPolicyFormModel["InputModel"];

	return inputModel;
};
